module.exports = __webpack_public_path__ + "img/tour-45.4dd174ba.png";